import React from 'react';
import { Operation } from '../../Transactions.types';
import * as S from './OperationRow.styles';
import { SmallChevronIcon } from '@/components/UI/Icons/Icons';
import { formatNumber } from '@/utils/helpers';

interface OperationRowProps {
  operation: Operation;
  onShowDetails: (operation: Operation) => void;
}

export function OperationRow({ operation, onShowDetails }: OperationRowProps) {
  const isIncome = operation.direction === 'income';

  return (
    <S.Row onClick={() => onShowDetails(operation)}>
      <S.Cell>
        {operation.ad ? (
          <S.AdLink
            href={operation.ad.path}
            onClick={event => event.stopPropagation()}
            title={operation.ad.title}
          >
            {operation.ad.title}
          </S.AdLink>
        ) : null}
      </S.Cell>

      <S.Cell title={operation.serviceName}>{operation.serviceName}</S.Cell>

      <S.Cell>
        <S.Amount $isIncome={isIncome}>
          {!isIncome && '−'}
          {formatNumber(operation.amount, 2)} ₼
        </S.Amount>
      </S.Cell>

      <S.Cell title={operation.paymentMethod}>{operation.paymentMethod}</S.Cell>

      <S.DateCell title={operation.date}>{operation.date}</S.DateCell>

      <S.ChevronCell>
        <SmallChevronIcon width={6} height={12} />
      </S.ChevronCell>
    </S.Row>
  );
}
